import getBrowserInfo from 'owa-user-agent/lib/utils/getBrowserInfo';
import { getUserNotificationPreferences } from 'mini-usercustomproperties/lib/api/getUserNotificationPreferences';
import { UserNotificationsPreference } from 'mini-usercustomproperties/lib/schema/UserNotificationPreference';

/**
 * Retrieves user's notification preference for current browser as stored in persistent storage (SDS).
 */
export const getUserNotificationsPreferenceForCurrentBrowser = async (): Promise<UserNotificationsPreference> => {
    const { browser } = getBrowserInfo();
    const preferences = await getUserNotificationPreferences();
    return preferences?.[browser] || null;
};
